module.exports = __webpack_public_path__ + "static/2010-layer-3-a22235e14dcf0e37895235d85f21b002.png";